<template lang="pug">
el-button(
  :type="type"
  :size="size"
  :icon="icon"
  :native-type="nativeType"
  :loading="loading"
  :disabled="disabled"
  :plain="plain"
  :round="round"
  :circle="circle"
  @click="handleClick"
)
  slot
</template>
  
<script>
  export default {
    name: 'BaseButton',
    props: {
      type: {
        type: String,
        default: 'outline'
      },
      size: {
        type: String,
        default: ''
      },
      icon: {
        type: String,
        default: ''
      },
      nativeType: {
        type: String,
        default: 'button'
      },
      loading: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      plain: {
        type: Boolean,
        default: false
      },
      round: {
        type: Boolean,
        default: false
      },
      circle: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      handleClick(event) {
        this.$emit('click', event);
      }
    }
  };
</script>
